import React from "react";
import styled from "styled-components";

import MoretonCardImage from "../content/images/distance-education/moreton-card.jpg";
import MarsdenParkCardImage from "../content/images/distance-education/marsdenpark-card.jpg";
import SouthlandsCardImage from "../content/images/distance-education/southlands-card.jpg";
import LauncestonCardImage from "../content/images/distance-education/launceston-card.jpg";
import VictoriaCardImage from "../content/images/distance-education/victoria-card.jpg";

const CARD_DETAILS = [
  {className: "moreton", href: "https://www.acc.edu.au/moreton/distance-education/", label: "ACC MORETON (QLD)", bgImage: MoretonCardImage},
  {className: "marsdenpark", href: "https://www.acc.edu.au/marsdenpark/distance-education/", label: "ACC MARSDEN PARK (NSW)", bgImage: MarsdenParkCardImage},
  {className: "southlands", href: "https://www.acc.edu.au/southlands/distance-education/", label: "ACC SOUTHLANDS (WA)", bgImage: SouthlandsCardImage},
  {className: "launceston", href: "https://www.acc.edu.au/launceston/distance-education/", label: "ACC LAUNCESTON (TAS)", bgImage: LauncestonCardImage},
  {className: "victoria", href: "https://www.acc.edu.au/victoria-online/", label: "ACC VICTORIA", bgImage: VictoriaCardImage}
];

const SchoolLinkGridWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .card {
    width: 100%;
    height: auto;
    min-height: 10rem;
    color: #fff;

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;

    margin: 0.5rem 0;
    border-radius: 5px;

    text-decoration: none;
    transition: all .5s ease;

    background-position: center;
    background-size: cover;

    &.gradient-bg {
      background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), var(--bg-image);

      &:hover {
        background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), var(--bg-image);
      }
    }

    &.moreton {
      --bg-image: url(${MoretonCardImage});
    }

    &.marsdenpark {
      --bg-image: url(${MarsdenParkCardImage});
    }

    &.southlands {
      --bg-image: url(${SouthlandsCardImage});
    }

    &.launceston {
      --bg-image: url(${LauncestonCardImage});
    }

    &.victoria {
      --bg-image: url(${VictoriaCardImage});
    }
  }

  @media (min-width: 768px) {
    .card {
      width: calc(50% - 1rem);
      margin: 1rem 0 1rem 0;

      &:nth-of-type(2n+1) {
        margin: 1rem 1rem 1rem 0;
      }

      &:nth-of-type(2n) {
        margin: 1rem 0 1rem 1rem;
      }
    }

  }
`;

const ThreeCardWrapper = styled(SchoolLinkGridWrapper)`
  .card {
    width: 100%;

    @media (min-width: 768px) {
      width: ${({cardsCount}) => (cardsCount === 2 ? 'calc(50% - 1rem)' : 'calc(33.3333% - 1rem)')};

      /* For every third element starting from the first (e.g., 1, 4, 7...),  */
      &:nth-of-type(3n+1) {
        margin: 1rem 1rem 1rem 0;
      }

      /* For every third element starting from the second (e.g., 2, 5, 8...),  */
      &:nth-of-type(3n+2) {
        margin: 1rem 0 1rem 1rem;
      }

      /* For every third element (e.g., 3, 6, 9...), */
      &:nth-of-type(3n) {
        margin: 1rem 0 1rem 1rem;
      }

    }
  }
`;

const CardLink = ({className, href, children}) => {
  // const bgImage = CARD_DETAILS.find(card => card.className === className).bgImage;

  return (
    <a className={`card gradient-bg ${className}`} href={href} target="_blank" rel="noreferrer">
      {children}
    </a>
  );
};


const DESchoolLinkGrid = ({hideVicOnline}) => {
  const cardsCount = !hideVicOnline ? 3 : 2;

  return (
    <>
      <SchoolLinkGridWrapper>
        <CardLink className="moreton" href={CARD_DETAILS[0].href}>{CARD_DETAILS[0].label}</CardLink>
        <CardLink className="marsdenpark" href={CARD_DETAILS[1].href}>{CARD_DETAILS[1].label}</CardLink>
      </SchoolLinkGridWrapper>
      <ThreeCardWrapper cardsCount={cardsCount}>
        <CardLink className="victoria" href={CARD_DETAILS[4].href}>{CARD_DETAILS[4].label}</CardLink>
        <CardLink className="southlands" href={CARD_DETAILS[2].href}>{CARD_DETAILS[2].label}</CardLink>
        <CardLink className="launceston" href={CARD_DETAILS[3].href}>{CARD_DETAILS[3].label}</CardLink>
      </ThreeCardWrapper>
    </>
  )
}

export default DESchoolLinkGrid;

